import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoSquare = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 30,
	viewBox: "0 0 31 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.22949 13.1392H17.1717V27.0813H13.4538V19.4866L6.80216 26.1382L4.1732 23.5092L10.8254 16.8571H3.22949V13.1392Z",
		fill: "#1C1D22"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.4542 2.91895H17.1722V10.5154L23.8256 3.86204L26.4545 6.491L19.8023 13.1432H27.3964V16.8611H19.7872L26.4697 23.5436L23.8407 26.1725L18.5606 20.8925V11.7088H9.377L4.15918 6.491L6.78814 3.86204L13.4542 10.5281V2.91895Z",
		fill: "#E6007E"
	})]
});
export default SvgLogoSquare;
